/**
 * Returns the base URL of the web app (where static assets like `/widget/*` are hosted).
 * Prefer `VITE_CLIENT_URL` when set so widget iframes and locale fetches match production
 * even if `VITE_AUTH0_CALLBACK_URL` points elsewhere.
 */
export const getClientUrl = () => {
  const explicit = import.meta.env.VITE_CLIENT_URL as string | undefined;
  if (explicit?.trim()) {
    return explicit.trim().replace(/\/$/, "");
  }
  const callback = import.meta.env.VITE_AUTH0_CALLBACK_URL as string | undefined;
  if (!callback?.trim()) {
    throw new Error(
      "Missing VITE_CLIENT_URL or VITE_AUTH0_CALLBACK_URL for getClientUrl()",
    );
  }
  return callback.replace(/\/callback\/?$/, "").replace(/\/$/, "");
};
